import React from 'react';
import { FlexMiddle } from '../../Flex';

const AgenciesChip = ({ externalOptions = {}, value }) => {
  const selectedValues = value ? (Array.isArray(value) ? value : [value]) : [];

  return (
    <FlexMiddle>
      {(externalOptions.agencies || [])
        .filter(({ value: optionValue }) => selectedValues.includes(optionValue))
        .map(({ label }) => label)
        .join(', ')}
    </FlexMiddle>
  );
};

export default AgenciesChip;
